import CardBase from "@/components/cards/CardBase";

interface AuthLayoutProps {
  children: React.ReactNode;
}

export default function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div
      className="min-h-screen flex items-center justify-center"
      style={{
        background:
          "linear-gradient(116deg, var(--Purple-1, #6E35FF) 0%, #30E38D 54.16%)",
      }}
    >
      <div className="w-full max-w-sm mx-4">
        <CardBase className="p-12" shadowType="black">
          {/* Logo */}
          <div className="flex justify-center mb-8 mt-8">
            <img src="/Grimoire_Woordmerk-Paars.png" alt="Grimoire" className="w-3/4 " />
          </div>
          {children}
        </CardBase>
      </div>
    </div>
  );
}

